const puzzle = {
  id: "54c883c20720491a5d",
  name: "Animal tracks on the screen",
  rebuses: [
    {
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "1111-017d-4115-b874-0de337bdc496",
            value: "Madagascar",
          },
        ],
        solvedText: "Madagascar",
      },
      style: {},
      id: "5555-2232-45f5-9cd0-fe8c25c0105c",
      clues: [
        {
          solutionInfo: {
            solvedText: "Lion",
            possibleSolutions: [
              {
                id: "1111-017d-4115-b874-0de337bdc496",
                value: "Lion",
              },
            ],
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              type: "image",
              value: "workshop/54c883c20720491a5d/6a.png",
              id: "6666-e918-4907-b0df-b80ed6db4f6d",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "",
          helperText: "",
          style: { width: "calc(25% - 10px)" },
          id: "7777-2a01-40eb-adb7-97f035fe22cc",
        },
        {
          solutionInfo: {
            solvedText: "Zebra",
            possibleSolutions: [
              {
                id: "1111-2222-4115-b874-0de337bdc496",
                value: "Zebra",
              },
            ],
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              type: "image",
              value: "workshop/54c883c20720491a5d/10a.png",
              id: "6666-3333-4907-b0df-b80ed6db4f6d",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "",
          helperText: "",
          style: { width: "calc(25% - 10px)" },
          id: "8888-4444-40eb-adb7-97f035fe22cc",
        },
        {
          solutionInfo: {
            solvedText: "Hippopotamus",
            possibleSolutions: [
              {
                id: "1111-2222-3333-1-0de337bdc496",
                value: "Hippopotamus",
              },
              {
                id: "1111-2222-3333-2-0de337bdc496",
                value: "Hippo",
              },
            ],
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              type: "image",
              value: "workshop/54c883c20720491a5d/5a.png",
              id: "6666-3333-4444-b0df-b80ed6db4f6d",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "",
          helperText: "",
          style: { width: "calc(25% - 10px)" },
          id: "8888-4444-5555-66-97f035fe22cc",
        },
        {
          solutionInfo: {
            solvedText: "Giraffe",
            possibleSolutions: [
              {
                id: "1111-2222-3333-12-0de337bdc496",
                value: "Giraffe",
              },
            ],
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              type: "image",
              value: "workshop/54c883c20720491a5d/4a.png",
              id: "6666-3333-4444-3-b80ed6db4f6d",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "",
          helperText: "",
          style: { width: "calc(25% - 10px)" },
          id: "8888-4444-5555-9-97f035fe22cc",
        },
      ],
    },
    {
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "1111-017d-4115-b874-k",
            value: "Pink Panther",
          },
        ],
        solvedText: "Pink Panther",
      },
      style: {},
      id: "121212-2232-45f5-9cd0-p",
      clues: [
        {
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              type: "text",
              value: "#DA9BAE",
              id: "6666-e918-4907-b0df-b80ed6db4f6d",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "",
          helperText: "",
          style: { width: "calc(25% - 10px)" },
          id: "7777-2a01-40eb-adb7-oiu",
        },
        {
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              type: "image",
              value: "workshop/54c883c20720491a5d/8a.png",
              id: "6666-3333-4907-s-b80ed6db4f6d",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "",
          helperText: "",
          style: { width: "calc(25% - 10px)" },
          id: "8888-4444-40eb-g-97f035fe22cc",
        },
      ],
    },
    {
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "1111-017d-4115-u-k",
            value: "Mickey Mouse",
          },
        ],
        solvedText: "Mickey Mouse",
      },
      style: {},
      id: "121212-2232-n-9cd0-p",
      clues: [
        {
          solutionInfo: {
            solvedText: "Mouse",
            possibleSolutions: [
              {
                id: "1111-017d-v-u-k",
                value: "Mouse",
              },
            ],
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              type: "image",
              value: "workshop/54c883c20720491a5d/7a.png",
              id: "6666-e918-4907-nh-b80ed6db4f6d",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "",
          helperText: "",
          style: { width: "calc(25% - 10px)" },
          id: "7777--j-40eb-adb7-oiu",
        },
        {
          solutionInfo: {
            solvedText: "Duck",
            possibleSolutions: [
              {
                id: "1111-017d-v-uasdasdsa-k",
                value: "Duck",
              },
            ],
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              type: "image",
              value: "workshop/54c883c20720491a5d/3a.png",
              id: "6666-e918-4907-nh-bgrfbztztt",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "",
          helperText: "",
          style: { width: "calc(25% - 10px)" },
          id: "7777--caxyyyyy-40eb-adb7-oiu",
        },
        {
          solutionInfo: {
            solvedText: "Dog",
            possibleSolutions: [
              {
                id: "1111-017d-v-uasdasdsa-kuzzzzz",
                value: "Dog",
              },
            ],
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              type: "image",
              value: "workshop/54c883c20720491a5d/2a.png",
              id: "6666-e918-4907-nhsaxxxxx-bgrfbztztt",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "",
          helperText: "",
          style: { width: "calc(25% - 10px)" },
          id: "7777--caxyyyyy-40ebqwqqq-adb7-oiu",
        },
      ],
    },
    {
      solutionInfo: {
        type: "text",
        possibleSolutions: [],
        solvedText: "The Road Runner Show",
      },
      style: {},
      id: "121212-2232-33333-9cd0-p",
      isUnlocked: true,
      clues: [
        {
          solutionInfo: {
            solvedText: "Roadrunner",
            possibleSolutions: [
              {
                id: "1111-017d-v-dssu-kcxy",
                value: "Roadrunner",
              },
              {
                id: "22222-017d-v-dssu-kcxy",
                value: "Road Runner",
              },
            ],
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              type: "image",
              value: "workshop/54c883c20720491a5d/9a.png",
              id: "6541-e918-4907-nh-b80ed6db4f6d",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "",
          helperText: "",
          style: { width: "calc(25% - 10px)" },
          id: "7777--j-40eb-adb7-oiu",
        },
        {
          solutionInfo: {
            solvedText: "Coyote",
            possibleSolutions: [
              {
                id: "1111-2244-v-uasdasdsa-kuzzzzz",
                value: "Coyote",
              },
            ],
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              type: "image",
              value: "workshop/54c883c20720491a5d/1a.png",
              id: "6666-e918-4907-nhsaxxxxx-bgrfbztztt",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "",
          helperText: "",
          style: { width: "calc(25% - 10px)" },
          id: "7777--caxyyyyy-12sa1-adb7-oiu",
        },
      ],
    },
  ],
};

export default puzzle;
